import React, { ReactNode } from 'react';
import { Paper, useMediaQuery, useTheme } from '@mui/material';

interface Children {
  children: ReactNode;
}

export const PaperPage: React.FC<Children> = ({ children }) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <Paper
      elevation={2}
      sx={{
        height: `calc(100vh - ${isSmallScreen ? 100 : 48}px)`,
        pb: 2,
        m: isSmallScreen ? 0 : 2,
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
      }}>
      {children}
    </Paper>
  );
};
